export const getPackingListMissingPickupOrDeliveryWarning = ({ watch }: { watch: any }) => {
  const packingListData = watch("packing_list");
  const stopsData = watch("schedule.stops");

  if (!packingListData || !stopsData || !packingListData.length || !stopsData.length)
    return { packingListStopWarnings: [], hasWarnings: false };

  const packingListStopWarnings = packingListData?.map((item: any) => {
    const { pickup_stop_key, delivery_stop_key } = item;
    if (!pickup_stop_key && !delivery_stop_key) return null;
    if (pickup_stop_key && !stopsData?.some((stop: any) => stop.stop_key === pickup_stop_key)) {
      return { warning: "Missing pickup stop key", stop_key: pickup_stop_key, item_description: item.description };
    }
    if (delivery_stop_key && !stopsData?.some((stop: any) => stop.stop_key === delivery_stop_key)) {
      return { warning: "Missing delivery stop key", stop_key: delivery_stop_key, item_description: item.description };
    }
    return null;
  });

  const hasWarnings = packingListStopWarnings.some((warning: any) => warning !== null);

  return { packingListStopWarnings, hasWarnings };
};
